<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content>
  <json-content-table *ngIf="!isLoading && jsonLog" [json]="jsonLog" displayStyle="log" title="Detail of Import Log">
  </json-content-table>
</page-content>
